export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./contextualMenu.vue?vue&type=template&id=dcd49fee&"


//////////////////
// WEBPACK FOOTER
// ./src/components/vuetable-2-kernel/compiled/template/contextualMenu.vue?vue&type=template&id=dcd49fee&
// module id = null
// module chunks = 